import {instance} from '../index';

export const subscriptionsStatusesApi = {
  getSubscriptionsStatuses () {
    return instance.get('subscriptions/statuses')
  },
}
